module.exports = __webpack_public_path__ + "media/images/Combined-Shape-a9808a517e7adaad97b150d063991fee.png";